// extracted by mini-css-extract-plugin
module.exports = {"badge":"HotkeyBadge_badge__vmvnK"};